import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeFileRequest = {
	id: number;
	initiativeId: number;
};

export const deleteInitiativeFile = createDeleteEndpoint<DeleteInitiativeFileRequest>(
	({ id, initiativeId }) => `/api/v3/initiatives/${initiativeId}/files/${id}`
);
